import {useInjex} from '@injex/react-plugin';
import EditChartsManager from '../managers/EditChartsManager.mdl';

export default function useEditChartsManager(): EditChartsManager {
    const [inject] = useInjex();
    return inject<EditChartsManager>('editChartsManager');
}
